import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ShieldCrossIcon = forwardRef<SVGSVGElement, IconProps>(function ShieldCrossIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9936 3C12.514 3 13.066 3.07052 13.5204 3.23269L13.5257 3.23459L17.7948 4.80021V4.80021C18.4339 5.0341 18.9787 5.50363 19.3609 6.04429C19.7432 6.58506 20 7.24947 20 7.91708V14.1383C20 14.757 19.7956 15.4259 19.4963 16.0082C19.1968 16.5908 18.7696 17.1505 18.2622 17.5216L14.5845 20.2083L14.5834 20.2091C13.8496 20.7486 12.9098 21 12 21C11.0903 21 10.1505 20.7486 9.41662 20.2092L9.41546 20.2083L5.73805 17.5218C5.23068 17.1507 4.80317 16.5908 4.50373 16.0082C4.2044 15.4259 4 14.757 4 14.1383V7.91708C4 7.25273 4.25749 6.59022 4.6395 6.05106C5.02142 5.51202 5.56568 5.04282 6.20439 4.80888L6.2052 4.80858L10.4732 3.235L10.4749 3.23437C10.9238 3.07031 11.4739 3 11.9936 3ZM10.9248 4.41064L10.924 4.41094L6.65469 5.985C6.30979 6.1112 5.96024 6.39122 5.69419 6.76671C5.42807 7.14231 5.28342 7.55993 5.28342 7.91708V14.1383C5.28342 14.5076 5.41271 14.9816 5.65028 15.4438C5.88766 15.9057 6.20043 16.2919 6.5058 16.5154M6.5058 16.5154L10.1867 19.2044C10.6591 19.5519 11.3145 19.744 12 19.744C12.6855 19.744 13.3409 19.5519 13.8133 19.2044L13.8151 19.2031L17.4939 16.5156C17.7994 16.2922 18.1123 15.9058 18.3497 15.4438C18.5873 14.9816 18.7166 14.5076 18.7166 14.1383V7.91708C18.7166 7.5548 18.5713 7.13491 18.3054 6.75883C18.0395 6.38267 17.6901 6.10279 17.3453 5.97662L13.0782 4.41175C12.8054 4.31487 12.4131 4.25596 11.9936 4.25596C11.5725 4.25596 11.1861 4.31531 10.9248 4.41064"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.74089 9.20626C9.9915 8.96102 10.3978 8.96102 10.6484 9.20626L14.2848 12.7648C14.5354 13.0101 14.5354 13.4077 14.2848 13.6529C14.0342 13.8982 13.6279 13.8982 13.3773 13.6529L9.74089 10.0944C9.49029 9.84912 9.49029 9.4515 9.74089 9.20626Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.242 9.24812C14.4926 9.49337 14.4926 9.89098 14.242 10.1362L10.6056 13.6948C10.355 13.94 9.94872 13.94 9.69811 13.6948C9.44751 13.4495 9.44751 13.0519 9.69811 12.8067L13.3345 9.24812C13.5851 9.00288 13.9914 9.00288 14.242 9.24812Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
